import { render, staticRenderFns } from "./ModuleCredentialForm.vue?vue&type=template&id=a8b13842"
import script from "./ModuleCredentialForm.vue?vue&type=script&lang=js"
export * from "./ModuleCredentialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports